import SectionRepository from "../repository/section-repository";

class SectionService
{
    #sectionRepository;

    constructor() {
        this.#sectionRepository = new SectionRepository();
    }

    async findAll() {
        try {
            const data = await this.#sectionRepository.getAll();

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {
            const data = await this.#sectionRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findOne(id) {
        try {
            const data = await this.#sectionRepository.getOneById(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async create(section) {
        try {
            const data = await this.#sectionRepository.create(section);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async edit(section) {
        try {
            const data = await this.#sectionRepository.edit(section);

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default SectionService;